import {
	BuildingOfficeIcon,
	MapPinIcon,
	PencilIcon,
	TrashIcon,
} from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'

import FilterableCell, { getRefId } from '@/widgets/FilterableCell'
import { getTriageOption } from '../../common/triageCategories'

const truncate = value => {
	const text = value || '-'
	return text.length > 50 ? `${text.slice(0, 47)}...` : text
}

export default function PlacowkiTableRow({
	placowka,
	isSelected,
	onSelectPlacowka,
	onEdit,
	onDelete,
	onMiastoFilter,
	onTypFilter,
}) {
	const placowkaId = placowka?._id || placowka?.id
	const triageOption = getTriageOption(placowka?.triage)
	const miastoId = getRefId(placowka?.id_miasto)
	const typId = getRefId(placowka?.id_typ)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 text-center">
				<input
					type="checkbox"
					checked={isSelected}
					onChange={e => onSelectPlacowka(placowkaId, e.target.checked)}
					className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300">
				<div className="flex flex-col gap-1">
					<div className="flex items-center gap-2 whitespace-nowrap">
						<BuildingOfficeIcon className="h-4 w-4 shrink-0 text-gray-400" />
						<Link
							to={`/klienci/placowki/details/${placowkaId}`}
							title={placowka?.nazwa || undefined}
							className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
							{truncate(placowka?.nazwa)}
						</Link>
					</div>
					<div
						className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-600"
						title={placowka?.adres || undefined}>
						<MapPinIcon className="h-4 w-4 shrink-0 text-gray-400" />
						<span>{truncate(placowka?.adres)}</span>
					</div>
				</div>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={miastoId}
					label={placowka?.id_miasto?.nazwa || '-'}
					onFilter={onMiastoFilter}
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={typId}
					label={placowka?.id_typ?.typ || '-'}
					onFilter={onTypFilter}
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				{triageOption ? (
					<span
						className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${triageOption.colorClass}`}>
						{triageOption.label}
					</span>
				) : (
					'-'
				)}
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
				<div className="inline-flex items-center gap-2">
					<button
						type="button"
						onClick={() => onEdit(placowka)}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100">
						<PencilIcon className="h-4 w-4" />
						<span>Edytuj</span>
					</button>
					<button
						type="button"
						onClick={() => onDelete(placowka)}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100">
						<TrashIcon className="h-4 w-4" />
						<span>Usuń</span>
					</button>
				</div>
			</td>
		</tr>
	)
}
